// export const environment = {
//     production: true,
//     API_URL: 'https://healable-notif-back-40009c7662fe.herokuapp.com',
//     Client_URL: 'https://test.healable.com',
//     environmentName: 'Development Environment',
//     ionicEnvName: 'Healable-systest',
//     awsAccessKey: 'AKIAJ56VAPWNAS2CXZWQ',
//     userAuthenticationApi: '503d8395-e1ad-45a5-8d75-2ad6515800cd',
//     awsSecretKey: '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',
//     bucketName: 'healable-systest',
//     Appname: 'Healable',
//     Version: 2.7,
//     sentry: 'https://7296ba226d424f3eaa127a787164d4b4@o130337.ingest.sentry.io/287690',
//     messagesToBeFetchedFromTwilioForHealableChat: 14,
//     messagesToBeFetchedFromTwilioForVideoChat: 25

// };
// export const environment = {
//     production: true,
//     API_URL: 'https://healable-systest.herokuapp.com',
//     Client_URL: 'https://test.healable.com',
//     environmentName: 'Development Environment',
//     ionicEnvName: 'Healable-systest',
//     awsAccessKey: 'AKIAJ56VAPWNAS2CXZWQ',
//     userAuthenticationApi: '503d8395-e1ad-45a5-8d75-2ad6515800cd',
//     awsSecretKey: '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',
//     bucketName: 'healable-systest',
//     Appname: 'Healable',
//     Version: 2.7,
//     sentry: 'https://7296ba226d424f3eaa127a787164d4b4@o130337.ingest.sentry.io/287690',
//     messagesToBeFetchedFromTwilioForHealableChat: 14,
//     messagesToBeFetchedFromTwilioForVideoChat: 25

// };
export const environment = {
    production: true,
    API_URL: 'https://healable-systest.herokuapp.com',
    Client_URL: 'https://test.healable.com',
    // AI_URL: 'https://healable-ai-backend-56c57cbb6257.herokuapp.com/api/evaluate',
    AI_URL: 'https://healable-ai-chat-history-back-93ce4f57781c.herokuapp.com/api/evaluate',
    AI_API_URL: 'https://healable-ai-chat-history-back-93ce4f57781c.herokuapp.com',
    environmentName: 'Development Environment',
    ionicEnvName: 'Healable-systest',
    awsAccessKey: 'AKIAJ56VAPWNAS2CXZWQ',
    userAuthenticationApi: '503d8395-e1ad-45a5-8d75-2ad6515800cd',
    awsSecretKey: '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',
    bucketName: 'healable-systest',
    Appname: 'Healable',
    Version: 2.7,
    sentry: 'https://7296ba226d424f3eaa127a787164d4b4@o130337.ingest.sentry.io/287690',
    messagesToBeFetchedFromTwilioForHealableChat: 14,
    messagesToBeFetchedFromTwilioForVideoChat: 25

};
